module.exports = __webpack_public_path__ + "img/g0.48670c97.jpg";